module.exports = __webpack_public_path__ + "02cd14be884736feea256d914bb84f8d.png";